const scrollToTopButton = document.getElementById('scrollToTopButton');

// Function to toggle the class based on scroll position
function toggleScrollToTopClass() {
	if (window.scrollY > 125) {
		scrollToTopButton.classList.add('scroll-to-top--visible');
	} else {
		scrollToTopButton.classList.remove('scroll-to-top--visible');
	}
}

scrollToTopButton.addEventListener('click', () => {
	// Scroll smoothly to the top of the page
	if ('scrollBehavior' in document.documentElement.style) {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	} else {
		// Fallback for older browsers
		window.scrollTo(0, 0);
	}
});

// Add scroll event listener to toggle class on scroll
window.addEventListener('scroll', toggleScrollToTopClass);

// Check if element with class 'em-page-navigation' exists
const pageNavigation = document.querySelector('.em-page-navigation');

if (pageNavigation) {
	// Find element with class 'scroll-to-top'
	const scrollToTop = document.querySelector('.scroll-to-top');

	if (scrollToTop) {
		// Add class 'scroll-to-top--offset-page-navigation'
		scrollToTop.classList.add('scroll-to-top--offset-page-navigation');
	}
}

// Initial check for scroll position on page load
toggleScrollToTopClass();
